module.exports = __webpack_public_path__ + "static/media/file-icon.b19a7218.svg";